import { findAllPrinter } from '../../_services/print.service';

export const findAllPrinterEvent = async () => {
    let res = await findAllPrinter();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}